import moment from 'moment'

export function dataToChart (data, ...values) {
  let readableNames = values.slice()
  readableNames.forEach((names, index) => {
    switch (names) {
      case 'weight':
        readableNames[index] = 'Gewicht'
        break
      case 'bloodsugar':
        readableNames[index] = 'Blutzucker'
        break
      case 'longtermSugar':
        readableNames[index] = 'Langzeitzucker'
        break
      case 'systolic':
        readableNames[index] = 'systolisch'
        break
      case 'diastolic':
        readableNames[index] = 'diastolisch'
        break
      case 'weeklyHoursMotion':
        readableNames[index] = 'Bewegung in Stunden'
        break
    }
  })
  let mappedData = [['Tag', ...readableNames]]
  data.map((item) => {
    item.systolic = item.bloodPressure.systolic
    item.diastolic = item.bloodPressure.diastolic

    if (values.includes('longtermSugar') && item.longtermSugar.unit === '%') {
      item.longtermSugar.value = ((parseInt(item.longtermSugar.value) - 2.12) * 10.929).toString() // && item.bloodsugar.unit = "mg/dl"
    }
    if (values.includes('bloodsugar') && item.bloodsugar.unit === 'mmol/l') {
      item.bloodsugar.value = ((parseInt(item.bloodsugar.value) * 18.02).toString()) // && item.bloodsugar.unit = "mg/dl"
    }
    mappedData.push([
      moment(item.trackingDay).format('DD.MM.YYYY'),
      ...values.map(v => parseInt(item[v].value))
    ])
  })
  return mappedData
}



// WEBPACK FOOTER //
// ./src/_helpers/dataToChart.js